/* istanbul ignore file */
import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  margin-bottom: ${spacing.md}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-bottom: ${spacing.xl}px;
    `,
  )}
`;
